import { setDeviceId } from "@amplitude/analytics-browser"
import { useEffect } from "react"
import { useLocation, useSearchParams } from "react-router-dom"

import { isVercelDeployment } from "../constants"
import { useUserQuery } from "../networking/user/queries"
import { trackAnalyticEvent } from "../util/analytics"

export const useAnalytics = () => {
  const location = useLocation()
  const { data: user } = useUserQuery()
  const [searchParams] = useSearchParams()
  const deviceId = searchParams.get("deviceId")

  useEffect(() => {
    if (!deviceId) return
    setDeviceId(deviceId)
    // masking the url if user is not logged in
    // because otherwise it will already redirect
    if (!user)
      window.history.replaceState(null, "Joon - Welcome", location.pathname)
  }, [deviceId, user, location])

  useEffect(() => {
    if (import.meta.env.DEV || isVercelDeployment) return
    trackAnalyticEvent("page:shown", { page: location.pathname })
  }, [location.pathname])
}
